<div
  class="container-fluid m-0 p-5 block"
  [ngClass]="{ 'theme-darkk': themeService.flag }"
>
  <div class="text-center">
    <h2 class="font-pacifico">
      <span
        class="text-underline cursor-pointer"
        (click)="navigate('\experience')"
        >Contact Me</span
      >.
    </h2>
  </div>
  <div class="row justify-content-center m-2">
    <div
      class="
        col col-md-6 col-12
        justify-content-center
        align-items-center
        text-center
      "
    >
      <div
        class="
          card
          d-flex
          justify-content-center
          depth
          align-items-center
          cursor-pointer
          my-2
        "
        (click)="navigate('\contact')"
        [ngClass]="{ 'theme-darkk': themeService.flag }"
      >
        <fa-icon [icon]="faEnvelope" class="fa-4x m-2"></fa-icon>
        <div class="d-block row justify-content-center align-items-center">
          <span
            class="font-oxygen"
            style="word-break: break-word; font-size: 1.25rem"
            >contact@tanaytoshniwal.me</span
          >
        </div>
      </div>
    </div>
    <div
      class="
        col col-md-6 col-12
        justify-content-center
        align-items-center
        text-center
      "
    >
      <div
        class="d-flex justify-content-center card depth align-items-center my-2"
        [ngClass]="{ 'theme-darkk': themeService.flag }"
      >
        <span
          class="font-oxygen m-2"
          style="word-break: break-word; font-size: 1.25rem"
          >Social Media</span
        >
        <div class="row justify-content-center align-items-center">
          <a
            *ngFor="let homeLink of home_links; let i = index"
            tabindex="-1"
            [href]="homeLink.href"
            target="_blank"
          >
            <button
              tabindex="-1"
              class="btn mx-1 btn-outline-light icon"
              [ngClass]="{ 'theme-darkk': themeService.flag }"
            >
              <i class="fa mx-2" [ngClass]="homeLink.iconClass"></i>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center m-2">
    <button class="button my-4 mx-auto" (click)="navigate('/resume')">
      <p class="h4 m-0 font-oxygen" [ngClass]="{ 'text-light': themeService.flag }">View/Download My Resume</p>
    </button>
  </div>
</div>
